<template>
  <div class="hzc-price-index">
    <div class="back">当前位置：<span @click="back('/oilBenzene')">石油苯</span> > <span
        @click="back('/oilBenzene/twoPage/price')">价格</span> > 正文
    </div>
    <DetailTitle :title="$route.query.id+'中石化石油苯挂牌价格'"></DetailTitle>
    <el-table
        :data="tableData"
        :header-cell-style="{background:'#f2f2f2',color:'#222'}"
        border
        style="width: 100%;margin-top: 20px;">
      <el-table-column
          align="center"
          prop="druidParamName"
          label="指标名称">
      </el-table-column>
      <el-table-column align="center" v-for="(item,index) in tabHead" :key="index">
        <template slot="header">
          <span>{{ item }}</span>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row[`price${index + 1}`] }}</span>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="unitName"
          label="单位">
        <template slot-scope="scope">
          <span>元/吨</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="echarts">
      <div id="myChart" style="width: 1100px;height:340px;"></div>
    </div>
  </div>
</template>

<script>
import DetailTitle from '@/components/common/detatilTitle'
import {priceDetail} from '@/api/oilBenzene'
import {stockDetailData} from "@/api/cokeBenzene";

export default {
  name: "priceIndex",
  components: {
    DetailTitle
  },
  data() {
    return {
      tableData: [],
      tabHead: [],
      dictId:'',
      queryParams:{
        endTime:'',
        dictDataType:'manual_entry_styrene_price'
      },
      option: {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          data: ["2019", '2020', '2021']
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月']
        },
        yAxis: {},
        series: [
        ],
        grid: {
          x: 100,
          y: 50,
          x2: 10,
          y2: 50
        },
      }
    }
  },
  created() {
    this.queryParams['endTime'] = this.$route.query.id;
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      priceDetail(this.queryParams).then(res => {
        this.tableData = res.data.data;
        this.tabHead = res.data['titleList'];
        this.dictId = this.tableData[0]['dictId']
        this.getMapData()
      })
    },
    /**
     * 获取地图信息
     */
    getMapData() {
      this.option['series'] = [];
      this.option['legend'].data = [];
      stockDetailData({dictId:this.dictId,endTime:this.$route.query.id,dictDataType: this.queryParams['dictDataType']}).then(res => {
        res.data.dataList.map((item,index) => {
          let obj = {
            name: item.yearName,
            type: "line",
            connectNulls:true,
            data: item.priceList,
          }
          this.option.series.push(obj);
          this.option.legend.data.push(item.yearName)
        })
        this.option['xAxis']['data'] = res.data['coordinate'];
        this.drawChart(this.option);
      })
    },
    back(url) {
      this.$router.push({path:url});
    },
    /**
     * 选择地图
     */
    chooseEchars(row) {
      this.dictId = row.row['dictId']
      this.getMapData()
    },
    /**
     * 加载地图
     */
    drawChart(option) {
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      myChart.setOption(option);
    }
  },
  mounted() {
    this.getDetail();
    /**
     * 加载地图
     */
  }
}
</script>

<style scoped lang="less">
.hzc-price-index {
  width: 1200px;
  margin: 0 auto;

  .tabs {
    margin: 15px 0;

    div {
      display: inline-block;
      margin-right: 16px;
      padding: 0 10px;
      height: 36px;
      background: #F2F2F2;
      border-radius: 4px;
      border: 1px solid #CCCCCC;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
    }

    div:hover {
      background-color: #D3131A;
      color: #fff;
    }
  }

  .slot-span {
    display: inline-block;
    text-align: center;
    line-height: 25px;
    width: 74px;
    height: 25px;
    background: #F2F2F2;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    cursor: pointer;
  }

  .slot-span:hover {
    background-color: #D3131A;
    border: 1px solid #D3131A;
    color: #fff;
  }

  .slot-hover {
    background-color: #D3131A;
    border: 1px solid #D3131A;
    color: #fff;
  }

  .echarts {
    margin-top: 24px;
    width:1140px;
    height: 351px;
    background: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(183, 183, 183, 0.5);
    padding: 30px;
  }
}

.hover {
  background-color: #D3131A !important;
  border: 1px solid #D3131A !important;
  color: #fff;
}

.back{
  span {
    cursor: pointer;
  }
}
.red {
  color: #EA6535;
}

.green {
  color: #079F93;
}

.gray {
  color: #999999;
}
</style>
